var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fc-designer',_vm._g(_vm._b({ref:"designer",attrs:{"config":_vm.useConfig}},'fc-designer',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }